<template>
  <div class="cotton-stat-detection">
    <MCard :title="$t('检测统计')" title-align="center">
      <Search
        v-bind="formConfig"
        :rules="rules"
        @search="search"
        @export="hisExport"
        :loading="searchLoading"
        :export-loading="exportLoading"
      />

      <el-row :gutter="40">
        <table-chart
          v-for="(v, i) in requestData"
          :normal-span="12"
          :key="i"
          :canvasName="i"
          :tableColumn="v.dimensions"
          :tableData="v.dataList"
          :chartOption="formatOption(v, i)"
          :title="title(i)"
          :color="statOpDict[i]().color"
        ></table-chart>
      </el-row>
    </MCard>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Search from './components/search.vue';
import MCard from '@/components/mCard/index.vue';

import { getCD603StatData } from '@/api/stat';
import { awaitTo, canvasToImg, downFile, getPreMonthRange } from '@/utils/utils';
import { busiOptions, statOpDict } from './data';
import { statChart } from '@/echartOption/stat';

export default {
  name: 'CottonDetectionStat',
  components: {
    Search,
    MCard,
    TableChart: () => import('@/components/table-chart')
  },
  inject: ['currentOfficeInfo'],
  data() {
    return {
      statOpDict,
      requestData: {},
      searchLoading: false,
      exportLoading: false,
      formConfig: {
        model: {
          sn: [],
          busiType: [],
          officeId: [this.currentOfficeInfo.officeId],
          dateRange: getPreMonthRange()
        }
      },
      rules: {
        // busiType: [
        //   {
        //     required: true,
        //     validator: (_rule, value, callback) => {
        //       const msg = this.$t('请选择统计类型');
        //       if (isEmpty(value)) {
        //         callback(new Error(msg));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
        // sn: [
        //   {
        //     required: true,
        //     validator: (_rule, value, callback) => {
        //       const msg = this.$t('请选择设备');
        //       if (isEmpty(value)) {
        //         callback(new Error(msg));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ]
      },
      formButton: [
        {
          text: '查询',
          event: this.search
        },
        {
          text: '导出',
          code: '010611',
          loading: false,
          event: this.hisExport
        }
      ]
    };
  },
  computed: {
    ...mapState('app', ['theme'])
  },
  methods: {
    async loadData() {
      const { sn, busiType, dateRange, officeId } = this.formConfig.model;

      const [err, res] = await awaitTo(
        getCD603StatData({
          sn,
          busiType,
          officeId,
          beginTime: dateRange[0],
          endTime: dateRange[1]
        })
      );

      this.requestData = res.data;

      if (err) {
        return this.$message.error(err.message);
      }

      return res;
    },

    async search() {
      this.searchLoading = true;

      await this.loadData();

      this.searchLoading = false;
    },
    formatOption(v, id) {
      const { dataList, dimensions } = v;
      const op = statOpDict[id]();
      if (dataList) {
        op.op.dataset = {
          source: dataList,
          dimensions
        };
        dimensions.slice(1).forEach(() => {
          if (op.seriesType === 'bar') {
            op.op.series.push({ type: op.seriesType, barMaxWidth: 20 });
          } else if (op.seriesType === 'barStack') {
            op.op.series.push({ type: 'bar', stack: 'total', barMaxWidth: 20 });
          } else {
            op.op.series.push({ type: op.seriesType });
          }
        });
      }
      return statChart(op.op, this.theme === 'light');
    },
    async hisExport() {
      this.exportLoading = true;

      await this.loadData();

      const { sn, busiType, dateRange, officeId } = this.formConfig.model;

      this.$nextTick().then(() => {
        canvasToImg().then(imgs => {
          downFile({
            url: '/stat/genCd603DataReport',
            method: 'post',
            data: {
              sn,
              busiType,
              officeId,
              beginTime: dateRange[0],
              endTime: dateRange[1],
              pics: imgs
            }
          }).finally(() => {
            this.exportLoading = false;
          });
        });
      });
    },
    title(id) {
      const res = busiOptions.filter(e => e.value == id)[0];
      return res && res.label;
    }
  },
  mounted() {
    this.search();
  }
};
</script>

<style lang="scss">
.cotton-stat-detection {
  height: 100%;
  box-sizing: border-box;

  .m-card_content {
    padding: 20px;
    box-sizing: border-box;

    overflow: auto;

    @include scrollar-style-thin;
  }
}
</style>
